"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftChevronIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../constants");
/**
 * Standard left chevron icon - https://www.figma.com/file/qPpy550VSNWIx9tBNcZJrG/SDS-WebC-Icons?node-id=1%3A6053
 */
function LeftChevronIcon(props) {
    const { className, "data-testid": dataTestId, fill = "#000000", size = constants_1.Sizes.Large } = props;
    return ((0, jsx_runtime_1.jsx)("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: fill, xmlns: "http://www.w3.org/2000/svg", className: className, "data-testid": dataTestId, children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.91132 12L15.5642 17.6529L14.15 19.0671L7.08289 12L14.15 4.93286L15.5642 6.34708L9.91132 12Z" }) }));
}
exports.LeftChevronIcon = LeftChevronIcon;
//# sourceMappingURL=LeftChevronIcon.js.map